module.exports = __webpack_public_path__ + "img/correct-circle.37775dd6.png";